"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.1 11.777V.017h9.534v4.206H14.9v11.759H5.367V4.223h4.267V1.018H2.1v9.759h1.5v1H1.1Zm12.8 3.206H6.368v-9.76H13.9v9.76Zm-4.266-2.092h1v-2.288h2.288v-1h-2.288V7.315h-1v2.288H7.346v1h2.288v2.288Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.654 17.573V0h14.17v6.428h6.522V24H8.176V6.428H14.7V1.125H2.779v15.323h3.327v1.125H1.654Zm19.566 5.302H9.301V7.554h11.92v15.321Zm-6.522-3.601h1.125v-3.498h3.498V14.65h-3.498v-3.497h-1.125v3.497h-3.497v1.125h3.497v3.498Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M2.206 23.43V0h18.892v8.57h8.697V32H10.902V8.57H19.6V1.5H3.705v20.43h4.437v1.5H2.206Zm26.088 7.07H12.402V10.071h15.892v20.43Zm-8.696-4.802h1.5v-4.663h4.663v-1.5h-4.663v-4.663h-1.5v4.663h-4.663v1.5h4.663v4.663Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M3.4 35.006V.075h28.09v12.919H44.6v34.931H16.51V12.994h13.108V1.95H5.274v31.182h6.881v1.874H3.4ZM42.726 46.05H18.383V14.868h24.343V46.05Zm-13.11-7.624h1.876v-7.03h7.03v-1.875h-7.03v-7.029h-1.875v7.03h-7.03v1.875h7.03v7.03Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M4.533 46.675V.1h37.455v17.225h17.478V63.9H22.01V17.325h17.478V2.6H7.032v41.576h9.175v2.499H4.533ZM56.968 61.4H24.51V19.824h32.457V61.4Zm-17.48-10.165h2.5v-9.373h9.374v-2.5h-9.373V29.99h-2.5v9.372h-9.372v2.5h9.372v9.373Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconDuplicate = function IconDuplicate(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Duplicate' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Duplicate"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconDuplicate.sizes = [16, 24, 32, 48, 64];
IconDuplicate.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconDuplicate;
exports.default = _default;